
















import Vue from 'vue'
import { mapGetters } from 'vuex'

export default Vue.extend({
  computed: {
    ...mapGetters([
      'product',
      'estimate',
      'estimateQuantity',
      'isSendable',
      'hasStock'
    ]),
    disableLink(): boolean {
      return !this.isSendable || !this.hasStock
    },
    linkToEstimatePreview() {
      return `${this.product.product_id}/estimate_preview?printable_sku_id=${this.estimate.printable_sku_id}&quantity=${this.estimateQuantity}&trial=${this.estimate.trial}`
    }
  }
})
